import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import Error from '@components/Error/Error'
import PageHeading from '@components/PageHeading/PageHeading'
import Pagination from '@components/Pagination/Pagination'
import Search from '@components/pages/Invoice/Search'
import Table from '@components/pages/Invoice/ListTable'
import GET_INVOICES from '@graphql/queries/get-invoices'

function List() {
  const [searchParams, setSearchParams] = useSearchParams()
  const searchFilters = Object.fromEntries(searchParams)
  const { data, loading, error, refetch } = useQuery(GET_INVOICES, {
    variables: { filters: searchFilters }
  })

  return (
    <>
      <PageHeading heading='Invoices' />

      {error ? (
        <Error error={error} />
      ) : (
        <>
          <Search
            refetch={refetch}
            searchFilters={searchFilters}
            setSearchParams={setSearchParams}
          />
          <Pagination
            onPageChange={(page) => setSearchParams({ ...searchFilters, page })}
            pageMetadata={data?.invoices?.metadata}
          />
          <Table
            totalCount={data?.invoices?.metadata?.totalCount}
            invoices={data?.invoices?.collection || []}
            loading={loading}
          />
          <Pagination
            onPageChange={(page) => setSearchParams({ ...searchFilters, page })}
            pageMetadata={data?.invoices?.metadata}
          />
        </>
      )}
    </>
  )
}

export default List
